

import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { InternshipDetailsListModel } from "./internship-details-data.model";


export class InternshipDetailsGridModel extends  InternshipDetailsListModel{}

export class InternshipDetailsListListingModel extends GridModel<InternshipDetailsGridModel> { 
    filterData: any;
}

export class InternshipDetailsGridParams extends GridPostParams {
    // pageNumber: 1;
    // pageSize: 10;
    // searchText: '';
    // direction: '';
    // column: ''
    // internshipCode: "I172077506811"
    internshipCode: any = ''
    
}

